import { ApiClient } from '@/lib/axios/client';
import type { MasterDataCategory, CreateMasterDataCategoryDto, UpdateMasterDataCategoryDto } from './types';

export class MasterDataCategoriesApi {
  static async list(orgId: string): Promise<MasterDataCategory[]> {
    return ApiClient.get<MasterDataCategory[]>(`/api/v1/orgs/${orgId}/master-data/categories`);
  }

  static async create(orgId: string, dto: CreateMasterDataCategoryDto): Promise<MasterDataCategory> {
    return ApiClient.post<MasterDataCategory>(`/api/v1/orgs/${orgId}/master-data/categories`, dto);
  }

  static async update(orgId: string, categoryId: number, dto: UpdateMasterDataCategoryDto): Promise<MasterDataCategory> {
    return ApiClient.patch<MasterDataCategory>(`/api/v1/orgs/${orgId}/master-data/categories/${categoryId}`, dto);
  }

  static async remove(orgId: string, categoryId: number): Promise<void> {
    return ApiClient.delete(`/api/v1/orgs/${orgId}/master-data/categories/${categoryId}`);
  }
}
